module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', {
    ref: "accordionItem",
    staticClass: "mail",
    attrs: {
      "isLoading": _vm.isLoading,
      "initial-active": _vm.initialActive,
      "initial-stay-active": _vm.initialStayActive,
      "injected": _vm.injected,
      "classes": {
        onObject: _vm.hasLinkedObject,
        unread: _vm.hasUnreadMessages
      }
    },
    on: {
      "load": _vm.loadObject,
      "toggleActive": _vm.activeChange
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('vue-object-img', {
    attrs: {
      "object": _vm.lastSender
    }
  }), _c('h4', [_vm._v(_vm._s(_vm._f("users")(_vm.conversation.senders))), _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" (" + _vm._s(_vm.nbMessages) + ")")])]), _c('h3', [(_vm.conversation.inCreation || _vm.newMessage) ? _c('div', {
    staticClass: "badge info"
  }, [_vm._v(_vm._s(_vm.$t('conversations.draft.short')))]) : _vm._e(), (_vm.conversation.unreadMessages > 0) ? _c('div', {
    staticClass: "badge info"
  }, [_vm._v(_vm._s(_vm.conversation.unreadMessages))]) : _vm._e(), _c('mark-text', [_vm._v(_vm._s(_vm.conversation.title))]), (_vm.firstUnreadMessageOrLastReadMessage != "") ? _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.firstUnreadMessageOrLastReadMessage))]) : _vm._e()], 1), _c('div', {
    staticClass: "max600 text-muted"
  }, [_vm._v(_vm._s(_vm.firstUnreadMessageOrLastReadMessage))]), (!_vm.conversation.inCreation) ? _c('div', {
    staticClass: "hoverbtns"
  }, [(!_vm.conversation.archived) ? _c('i', {
    staticClass: "fa fa-archive",
    attrs: {
      "title": _vm.$t("conversations.titles.archive")
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      },
      "click": function($event) {
        $event.stopPropagation();
        return _vm.archive($event)
      }
    }
  }) : _vm._e(), (_vm.conversation.archived) ? _c('i', {
    staticClass: "fa fa-inbox",
    attrs: {
      "title": _vm.$t("conversations.titles.toInbox")
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      },
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toInbox($event)
      }
    }
  }) : _vm._e()]) : _vm._e(), (!_vm.conversation.inCreation) ? _c('div', {
    staticClass: "menu doNotDesactiveOnClick dropbox"
  }, [_c('div', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v"
  })]), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('li', {
    on: {
      "click": _vm.markAsUnread
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('conversations.menu.markAsUnread')))])]), (!_vm.conversation.archived) ? _c('li', {
    on: {
      "click": _vm.archive
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('conversations.menu.archive')))])]) : _vm._e(), (_vm.conversation.archived) ? _c('li', {
    on: {
      "click": _vm.toInbox
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('conversations.menu.toInbox')))])]) : _vm._e()])]) : _vm._e(), (_vm.hasLinkedObject) ? [_c('shared-object-abstract', {
    attrs: {
      "sharedObject": _vm.conversation.onObject
    },
    on: {
      "click": _vm.openObjectPopup
    }
  })] : _vm._e()], 2), _c('template', {
    slot: "body"
  }, [(!_vm.conversation.inCreation && _vm.conversation.participants.length > 0) ? _c('div', {
    staticClass: "toDiv",
    class: {
      showNames: _vm.showNameInParticipants
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.toggleNameInParticipants
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('conversations.participants')))]), _c('ul', _vm._l((_vm.conversation.participants), function(participant) {
    return _c('li', {
      key: participant.id
    }, [(participant.kind != "email") ? _c('vue-object-img', {
      attrs: {
        "object": participant
      }
    }) : _c('i', {
      staticClass: "fa fa-envelope",
      attrs: {
        "title": participant.name
      }
    }), (_vm.showNameInParticipants) ? [_vm._v("   " + _vm._s(participant.name) + "    ")] : _vm._e()], 2)
  }), 0)]) : _vm._e(), (_vm.hasLinkedObject && !_vm.injected) ? [_c('shared-object-abstract', {
    attrs: {
      "sharedObject": _vm.conversation.onObject
    },
    on: {
      "click": _vm.openObjectPopup
    }
  })] : _vm._e(), _vm._l((_vm.messages), function(message, index) {
    return [(_vm.messageAtIndexIsHidden(index) && !_vm.hasPreviousHiddenMessage(index)) ? [_c('div', {
      staticClass: "hiddenMessages doNotDesactiveOnClick",
      on: {
        "click": _vm.showAllMessages
      }
    }, [_c('div', {
      staticClass: "clickToShow"
    }, [_vm._v(_vm._s(_vm.nbHiddenMessagesAtIndex(index)))])])] : _vm._e(), (!_vm.messageAtIndexIsHidden(index)) ? _c('message', {
      key: message.id,
      attrs: {
        "message": message,
        "reduced": _vm.messageIsReduced(index)
      }
    }) : _vm._e()]
  }), (_vm.answering) ? _c('div', {
    staticClass: "answerDiv form-horizontal"
  }, [(_vm.conversation.inCreation) ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.conversation.title),
      expression: "conversation.title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "titleInput",
    class: {
      'error': _vm.errors.has('title')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t("conversations.creation.objectPlaceholder"),
      "tabindex": "1",
      "name": "title"
    },
    domProps: {
      "value": (_vm.conversation.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.conversation, "title", $event.target.value)
      }
    }
  }), _c('div', {
    staticClass: "toMessage doNotDesactiveOnClick",
    class: {
      'error': _vm.errors.has('to')
    }
  }, [_c('div', {
    ref: "toInput",
    staticClass: "clearfix"
  })])] : _vm._e(), _c('div', {
    staticClass: "answer"
  }, [_c('vue-object-img', {
    attrs: {
      "object": _vm.user
    }
  }), _c('textarea-autosize', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "textarea",
    class: {
      'error': _vm.errors.has('newMessage')
    },
    attrs: {
      "tabindex": "3",
      "placeholder": _vm.$t("conversations.creation.messagePlaceholder"),
      "name": "newMessage"
    },
    nativeOn: {
      "blur": function($event) {
        return _vm.blurTextarea($event)
      }
    },
    model: {
      value: (_vm.newMessage),
      callback: function($$v) {
        _vm.newMessage = $$v
      },
      expression: "newMessage"
    }
  }), _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendMessage
    }
  }, [_vm._v(_vm._s(_vm.$t("conversations.answerDiv.send")))]), (_vm.conversation.inCreation || _vm.newMessage) ? _c('a', {
    staticClass: "pull-right btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.forgetMessage
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })]) : _vm._e(), (_vm.newMessage) ? _c('small', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [(_vm.draftStatus == _vm.STATUS.SAVING) ? [_vm._v(_vm._s(_vm.$t('conversations.draft.saving')))] : _vm._e(), (_vm.draftStatus == _vm.STATUS.SAVED) ? [_vm._v(_vm._s(_vm.$t('conversations.draft.success')))] : _vm._e(), (_vm.draftStatus == _vm.STATUS.ERROR) ? [_vm._v(_vm._s(_vm.$t('conversations.draft.error')))] : _vm._e()], 2) : _vm._e()])], 1)], 2) : _vm._e(), (_vm.isWriting) ? _c('div', {
    staticClass: "isWriting"
  }, [_vm._v(_vm._s(_vm.$t('conversations.isWriting')))]) : _vm._e(), (!_vm.answering) ? _c('div', {
    staticClass: "footer",
    on: {
      "click": _vm.enableAnswer
    }
  }, [_c('vue-object-img', {
    attrs: {
      "object": _vm.user
    }
  }), (_vm.nbMessages > 0) ? [_vm._v(_vm._s(_vm.$t("conversations.answerDiv.footer.answer")))] : _vm._e(), (_vm.nbMessages == 0) ? [_vm._v(_vm._s(_vm.$t("conversations.answerDiv.footer.startConversation")))] : _vm._e()], 2) : _vm._e()], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7d7b582","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Conversations/Conversation.vue
// module id = 903
// module chunks = 13